import React from 'react'
import { ApplicationStatsSection } from '../../api/Types'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'

type Props = ApplicationStatsSection

const LandingPageApplicationStats: React.FC<Props> = ({ stats, style }) => {
  return (
    <>
      <LandingPageSectionWrapper cssNamespace='application-stats-section' style={style}>
        <div className='application-stats-section-container'>
          {stats.map(stat => (
            <div key={stat.label} className='stat-container'>
              <div className='value-container'>
                <div className='left-border' />
                <h3 className='value-text'>{stat.value}</h3>
              </div>
              <p className='label-text'>{stat.label}</p>
            </div>
          ))}
        </div>
      </LandingPageSectionWrapper>
    </>
  )
}

export default LandingPageApplicationStats
